//@ts-nocheck
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';

const SummaryCard = styled(Card)`
  background-color: #f8f9fa;
  border: 2px solid #dee2e6;
`;

const SummaryValue = styled.span`
  font-size: 1.2em;
  font-weight: bold;
  color: #28a745;
`;

const OrderSummary = ({ totalQuantity, totalPrice }) => {
  return (
    <SummaryCard className="mb-4">
      <Card.Header>
        <h6 className="mb-0">Podsumowanie zamówienia</h6>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <div className="d-flex justify-content-between align-items-center">
              <span>Łączna ilość produktów:</span>
              <SummaryValue>{totalQuantity} szt.</SummaryValue>
            </div>
          </Col>
          <Col md={6}>
            <div className="d-flex justify-content-between align-items-center">
              <span>Łączna wartość zamówienia:</span>
              <SummaryValue>{totalPrice.toFixed(2)} PLN</SummaryValue>
            </div>
          </Col>
        </Row>

        {totalQuantity === 0 && (
          <div className="text-center mt-3">
            <small className="text-muted">
              Wybierz ilości produktów aby utworzyć zamówienie
            </small>
          </div>
        )}
      </Card.Body>
    </SummaryCard>
  );
};

export default OrderSummary;
